module.exports = __webpack_public_path__ + "static/media/Galleria - DK Chocolate_Orange - DK Chocolate.958a1264.jpg";